import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionType, CompetitionTypes, CompetitionsUsersType } from "../../services/CompetitionsService";
import { DefaultButton, PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import styles from './index.module.sass';

import BackButton from "../../components/buttons/BackButton";
import { useHistory, useLocation } from "react-router";
import ContractDocsService, { ContractDocsVersionType } from "../../services/ContractDocsService";
import { ErrorModal } from "../../components/Modals/ErrorModal";
import { ISignature } from "../../services/SignaturesService";
import { UserType } from "../../services/UserService";
import Auth from "../../Auth/Auth";
import moment from "moment";
import PaymentService, { PaymentType } from "../../services/PaymentService";
import InespayService from "../../services/InespayService";
import { SignatureComponentWithUserNoUserIdentity } from "../../components/Signature/SignatureComponentWithUserNoUserIdentity";
import { SignatureComponent } from "../../components/Signature/SignatureComponent";
import { UserIdentityType } from "../../services/UserIdentitiesService";
import { GenericMessageModalWithoutButton } from "../../components/Modals/GenericModal";
import { createurl } from "../../utils/createUrl";


const CompetitionContractActivePlan = () =>
{

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState({ status: false, message: "" });
    const [sending, setSending] = useState<boolean>(false);

    const location = useLocation();
    const history = useHistory();
    const user = Auth.getUserProfile();

    const state = location?.state as any;
    const { competition, competitionUserObject, wantElements } = state;
    const [contractHTML, setContractHTML] = useState<string>('');

    const [signatureCompetition, setSignatureCompetition] = useState<ISignature>();

    const [phoneNumber, setPhoneNumber] = useState("");
    const [finalUserInCompetition, setFinalUserInCompetition] = useState<UserIdentityType>();
    const [signatureId, setSignatureId] = useState<number>(-1);
    const [canceling, setCanceling] = useState<boolean>(false);
    const [isModal, setIsModal] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() =>
    {
        ContractDocsService.getContractVersionById(competition.asociatedContractId).then((contractDocsVersion: ContractDocsVersionType) =>
        {
            setContractHTML(contractDocsVersion.text);
        }).finally(() =>
        {
            setLoading(false);
        })
    }, []);

    useEffect(() =>
    {
        if (signatureId !== -1 && state.fromEmail == true)
        {
            history.push(`/competition/${createurl(competition.name)}-${competition.id}`, { competitionId: competition.id });
        }
        else
        {
            if (signatureId !== -1 && competition != undefined && signatureCompetition != undefined && finalUserInCompetition != undefined)
            {
                //Puede ser CASO A o CASO C
                // A. € - nuestra plataforma - SI contrato ===> contrato - firma (SMS) - inespay
                // C. € - OTRA plataforma - SI contrato    ===> contrato - firma (SMS) - url

                if (competition?.typeOfPrice === 3)
                {
                    console.error("La competición por pago externo no debe incluir un contrato asociado.");
                    return setError({ status: true, message: "Se ha producido un error con la competición. Porfavor, contacta con info@ironia.tech." });

                } else
                {

                    if (wantElements == true)
                    {
                        setIsModal(true);
                        setShowModal(true);
                    } else
                    {

                        //CASO A
                        var reference = `${user.id}-O${signatureCompetition.id}`;

                        let subject = `Competición IronIA - ${finalUserInCompetition.id} - ${user.id}`;

                        const data = {
                            reference: reference,
                            subject: subject,
                            amount: competition.price,
                            status: 1,
                            platform: "INESPAY",
                            orders: undefined,
                            usersSubscriptionId: undefined,
                            savingsPlanId: competitionUserObject.savingsPlanId
                        }

                        //en este paso, 
                        PaymentService.createPaymentFromCompetition(data, finalUserInCompetition.id!).then((data: Partial<PaymentType>) =>
                        {
                            InespayService.postInespay(
                                {
                                    reference: reference,
                                    subject: subject,
                                    amount: ((competition.price) * 100).toString(),
                                    subscription: false
                                }).then((dataInespay: any) =>
                                {
                                    const inespay_result = JSON.parse(dataInespay.Result);
                                    if (inespay_result.status === '200')
                                    {
                                        window.location.href = inespay_result.url;
                                    }
                                    else
                                    {
                                        if (inespay_result.status === "E301")
                                        {
                                            console.log("El IBAN introducido no es válido.");
                                        }
                                        else
                                        {
                                            console.log(inespay_result.description);
                                        }
                                    }
                                },
                                    (error: any) => { });
                        },
                            (error: any) => { });

                    }
                }


            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signatureId]);


    const processExpirationDate = (signature: ISignature) =>
    {
        if (signature && typeof signature.expiresAt === "string")
        {
            signature.expiresAt = moment(signature.expiresAt).toDate();
        }
    };



    const createSign = async () =>
    {
        if (state.fromEmail == true)
        {
            const createSignature = await CompetitionsService.patchSignatureWithEmailActivePlan(competitionUserObject.id, user.email);
            var operationPhone = createSignature.user.userIdentities[0].operationPhone;

            setFinalUserInCompetition(createSignature);
            setSignatureCompetition(createSignature.signature);

            setPhoneNumber(
                "X".repeat(operationPhone.length - 3) + operationPhone.slice(operationPhone.length - 3, operationPhone.length)
            );
        } else
        {
            const createSignature = await CompetitionsService.patchSignatureActivePlan(competitionUserObject.id, wantElements != undefined ? wantElements : false);
            var operationPhone = createSignature.user.userIdentities[0].operationPhone;

            setFinalUserInCompetition(createSignature);
            setSignatureCompetition(createSignature.signature);

            setPhoneNumber(
                "X".repeat(operationPhone.length - 3) + operationPhone.slice(operationPhone.length - 3, operationPhone.length)
            );
        }
    }

    const handleSubmit = (response: any) =>
    {
        if (response.data.success === true && signatureCompetition != undefined && signatureCompetition.id != undefined)
        {
            setSignatureId(signatureCompetition.id);
        }
    };

    const cancelParticipation = () =>
    {
        setCanceling(true);
        CompetitionsService.inscribeInCompetitionStatusCancel(competitionUserObject.id).then((data) =>
        {
            if (data == true)
            {
                history.push("/competitions")
            }
            else
            {
                setError({ status: true, message: data })
            }
        })
    }


    if (location == undefined || state == undefined)
    {
        return (
            <DocumentTitle title="IronIA - Competiciones">
                <div>
                    <BackButton />
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <h2>Competiciones</h2>
                        </div>
                    </div>
                    <p style={{ marginTop: "20px" }}>Error: No hemos podido procesar tu petición. Porfavor, vuelve a intentarlo.</p>

                </div>
            </DocumentTitle>
        );
    }

    return (<DocumentTitle title="IronIA - Competiciones">
        <section className={`${styles.index}`}>
            <BackButton />
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <h2>Competiciones</h2>
                </div>
            </div>
            {loading && <Spinner size={SpinnerSize.large} />}
            {!loading && <>
                <div dangerouslySetInnerHTML={{ __html: contractHTML }}></div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "right",
                        marginTop: "30px"
                    }}
                >
                    <DefaultButton
                        className="button tiny-primary-button"
                        onClick={cancelParticipation}
                        disabled={canceling}
                    >
                        {canceling && (
                            <Spinner
                                size={SpinnerSize.small}
                                className="button-spinner"
                            />
                        )}
                        Cancelar
                    </DefaultButton>

                    <DefaultButton
                        className="button tiny-primary-button"
                        type="submit"
                        disabled={
                            sending || signatureCompetition != undefined
                        }
                        onClick={createSign}
                    >
                        {sending && (
                            <Spinner
                                size={SpinnerSize.small}
                                className="button-spinner"
                            />
                        )}
                        Participar
                    </DefaultButton>
                </div>
                {(signatureCompetition !== undefined || signatureCompetition != null) && finalUserInCompetition !== undefined
                    && <SignatureComponent
                        signatures={[signatureCompetition]}
                        title="Participar en la competición"
                        submitButtonText="Firmar"
                        requestNewCodeButtonText="Recibir nuevo código"
                        headerTextArea={`Confirma la aceptación con la clave enviada a tu teléfono ${phoneNumber}.`}
                        onBackButtonClicked={cancelParticipation}
                        onCancelButtonClicked={cancelParticipation}
                        userIdentities={[finalUserInCompetition]}
                        cancelButtonText="Cancelar"
                        alreadySignedText="La firma ha sido guardada. Espere mientras procesamos la información..."
                        onNewCodeSended={(signatures: any) =>
                        {
                            signatures.forEach((signature: any) =>
                            {
                                processExpirationDate(signature);
                            });
                            setSignatureCompetition(signatures[0]);
                        }}
                        onSignatureChanged={(signature: any) =>
                        {
                            processExpirationDate(signature);
                            setSignatureCompetition(signature);
                        }}
                        onSigned={(response: any, signatures: any) =>
                        {
                            {
                                processExpirationDate(signatures);
                                //setSignatureCompetition(signatures);
                                handleSubmit(response);
                            }
                        }}
                    />
                }
                {isModal && (
                    <GenericMessageModalWithoutButton
                        title="Inscripción registrada"
                        body={
                            competition != undefined ?
                                <p> Tu inscripción ha sido registrada. Pulsa el boton aceptar para continuar.</p> :
                                <p> Tu inscripción ha sido registrada. Pulsa el boton aceptar para continuar.</p>
                        }
                        btnSubmitText="Aceptar"
                        showModal={showModal}
                        onSubmit={() =>
                        {
                            setShowModal(false);
                            history.push("/competitions");
                        }}
                        onClose={() =>
                        {
                            setShowModal(false);
                            history.push("/competitions");
                        }}
                    ></GenericMessageModalWithoutButton>
                )}
                <ErrorModal
                    title="Ha ocurrido un error al procesar tu solicitud"
                    body={
                        <div>
                            <p>{error.message}</p>
                        </div>
                    }
                    btnSubmitText="Aceptar"
                    showModal={error.status}
                    onSubmit={() =>
                    {
                        setError({ status: false, message: "" });
                    }}
                    onClose={() =>
                    {
                        setError({ status: false, message: "" });
                    }}
                /></>
            }
        </section>
    </DocumentTitle>)
};

export default CompetitionContractActivePlan;
